/**
 * RegionBordersLayerContainer - Container Component
 *
 * Container component responsible for:
 * - Zustand store connection (useStore, useStorePrimitive)
 * - Reading mapRegions, activeMapId, and showMapRegions from the store
 * - Delegating presentation to the pure RegionBordersLayer component
 *
 * This follows the Container/Presenter pattern as defined in ADR-034.
 * @see docs/adr/0034-container-presenter-component-pattern.md
 */

import React from 'react';
import { useStore, useStorePrimitive } from '../../hooks/useStore';
import RegionBordersLayer from './RegionBordersLayer';
import type { MapRegion, RenderedImageRect } from '../../types/types';
import type { Stage } from 'konva/lib/Stage';

const emptyRegions: MapRegion[] = [];

interface RegionBordersLayerContainerProps {
  imageRect: RenderedImageRect | null;
  stageRef: React.RefObject<Stage | null>;
}

const RegionBordersLayerContainer: React.FC<RegionBordersLayerContainerProps> = ({ imageRect, stageRef }) => {
  const mapRegions = useStore(state => state.session?.map?.mapRegions) || emptyRegions;
  const activeMapId = useStorePrimitive(state => state.session?.map?.activeMapId);
  const showMapRegions = useStorePrimitive(state => state.settings?.showMapRegions);

  return (
    <RegionBordersLayer
      imageRect={imageRect}
      stageRef={stageRef}
      mapRegions={mapRegions}
      activeMapId={activeMapId}
      showMapRegions={showMapRegions}
    />
  );
};

export default RegionBordersLayerContainer;
